import { APIv4 } from 'src/libs/axios';

export const deleteMenuCategory = ({
  menuId,
  id,
}: {
  menuId: number;
  id: number;
}): Promise<void> =>
  APIv4.delete(`/menus/${menuId}/categories/${id}`).then(
    (response) => response.data
  );
